var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDotSolidGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7131_10605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5322 24.375C13.0371 21.2402 18.75 13.6426 18.75 9.375C18.75 4.19922 14.5508 0 9.375 0C4.19922 0 0 4.19922 0 9.375C0 13.6426 5.71289 21.2402 8.21777 24.375C8.81836 25.1221 9.93164 25.1221 10.5322 24.375ZM9.375 6.25C10.2038 6.25 10.9987 6.57924 11.5847 7.16529C12.1708 7.75134 12.5 8.5462 12.5 9.375C12.5 10.2038 12.1708 10.9987 11.5847 11.5847C10.9987 12.1708 10.2038 12.5 9.375 12.5C8.5462 12.5 7.75134 12.1708 7.16529 11.5847C6.57924 10.9987 6.25 10.2038 6.25 9.375C6.25 8.5462 6.57924 7.75134 7.16529 7.16529C7.75134 6.57924 8.5462 6.25 9.375 6.25Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7131_10605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDotSolidGreen);
export default __webpack_public_path__ + "static/media/location-dot-solid-green.f5552c276a6b100d4da243b7dfe16300.svg";
export { ForwardRef as ReactComponent };